import { Paper, styled } from "@mui/material";

import { palette } from "~frontend/theme";

export const ControlsPaper = styled(
  Paper,
  {}
)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  paddingBottom: theme.spacing(2),
  backgroundColor: palette.lightGray,

  "&:first-of-type": {
    [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
      flexDirection: "column",
    },
  },
}));

export const ControlsRow = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
});

export const ButtonWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
